export const checkPermissions = (type, permissions, permission) => {
    if (type === 'Parent') {
        return true;
    }

    if (!permission || !Array.isArray(permissions)) {
        return false;
    }

    const [subjects, action] = String(permission).split('-');

    return subjects.split(',').some((subject) => {
        const permissionItem = permissions.find(
            (item) => item?.permission?.subject === subject.trim()
        );

        if (!permissionItem) {
            return false;
        }

        return action === undefined ||
            (Array.isArray(permissionItem.actions) && permissionItem.actions.includes(action));
    });
};
